var _g, _circle, _path, _path2, _path3, _path4, _circle2, _circle3, _circle4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 780,
    height: 251,
    viewBox: "0 0 780 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4720_185679)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20V185.097C302.115 273.855 472.989 272.077 780 185.097V20C780 8.95431 771.046 0 760 0H20C8.95431 0 0 8.95429 0 20Z",
    fill: "#5DA196"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 374.5,
    cy: 33.5,
    r: 7.5,
    stroke: "#F9CF62",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.154 52.6056C183.079 51.0678 184.696 50.0251 186.066 50.7286L194.539 55.0819C195.909 55.7855 196.003 57.7077 194.709 58.5419L186.702 63.7034C185.408 64.5376 183.696 63.6582 183.621 62.1204L183.154 52.6056Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.728 166.739C108.728 168.279 107.061 169.241 105.728 168.471L97.4778 163.708C96.1445 162.938 96.1445 161.014 97.4778 160.244L105.728 155.481C107.061 154.711 108.728 155.673 108.728 157.213L108.728 166.739Z",
    fill: "#F9CF62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M595.58 61.6853C594.593 62.8674 592.697 62.5385 592.167 61.0933L588.884 52.1506C588.353 50.7053 589.586 49.2276 591.103 49.4907L600.489 51.1188C602.006 51.382 602.669 53.1886 601.683 54.3707L595.58 61.6853Z",
    fill: "#F9CF62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M531.645 194.908C532.733 193.82 534.592 194.318 534.991 195.805L537.456 205.007C537.855 206.494 536.494 207.854 535.007 207.456L525.805 204.99C524.318 204.592 523.82 202.733 524.909 201.644L531.645 194.908Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.5,
    cy: 79.5,
    r: 7.5,
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.877,
    cy: 155.197,
    r: 5.44888,
    transform: "rotate(-15 218.877 155.197)",
    fill: "white",
    fillOpacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 680.043,
    cy: 176.3,
    r: 7.38522,
    transform: "rotate(-15 680.043 176.3)",
    fill: "#F9CF62"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4720_185679",
    x: 0,
    y: 0,
    width: 780,
    height: 255,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4720_185679"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGreen);
export default __webpack_public_path__ + "static/media/bg-green.d39bf5e198e120132e80ab178bf4b044.svg";
export { ForwardRef as ReactComponent };